'use strict';

exports.__esModule = true;

var _postcss = require('postcss');

var _postcss2 = _interopRequireDefault(_postcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _postcss2.default.plugin('postcss-strip-inline-comments', function () {
    return function (css) {
        css.walkComments(function (i) {
            if (i.raws.inline) i.remove();
        });
    };
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/postcss-strip-inline-comments/lib/strip-inline-comments.js
// module id = 731
// module chunks = 3 4